import React, { useState, useEffect } from "react";
import "./Lotoreya.css";
import LotoreyaCard from "../../components/LotoreyaCard";
import LotoreyaController from "../../api/lotoreya/LotoreyaController";
import ElanController from "../../api/elan/ElanController";
import BiletController from "../../api/lotoreya/BiletController";
import moment from "moment";
import "moment/locale/az";
import UserController from "../../api/user/UserController";
import { useNavigate } from "react-router-dom";
import { FaTiktok, FaWhatsapp } from "react-icons/fa";

const Lotoreya = () => {
  const [lotoreyas, setLotoreyas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [balanceMessage, setBalanceMessage] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedLotoreyaForBuy, setSelectedLotoreyaForBuy] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadLotoreyas = async () => {
      try {
        const all = await LotoreyaController.getAllLotoreyas();

        for (let lotoreya of all) {
          const elan = await ElanController.getElanById(lotoreya.elanId);
          lotoreya.elan = elan;

          // Əgər carx və winnerUserId var amma winnerUser yoxdursa → çək
          if (lotoreya.carx?.winnerUserId && !lotoreya.carx?.winnerUser?.name) {
            try {
              const winnerUser = await UserController.getUserById(lotoreya.carx.winnerUserId);
              lotoreya.carx.winnerUser = winnerUser;
            } catch (err) {
              console.warn(`Qalib istifadəçi yüklənmədi: ${lotoreya.carx.winnerUserId}`, err);
            }
          }

          // Əgər ümumiyyətlə carx yoxdur → çək
          if (!lotoreya.carx && lotoreya.id) {
            try {
              const fullLotoreya = await LotoreyaController.getLotoreyaById(lotoreya.id);
              lotoreya.carx = fullLotoreya.carx;

              // Burda da yenə yoxlayırıq qalib varsa:
              if (lotoreya.carx?.winnerUserId && !lotoreya.carx?.winnerUser?.name) {
                const winnerUser = await UserController.getUserById(lotoreya.carx.winnerUserId);
                lotoreya.carx.winnerUser = winnerUser;
              }
            } catch (err) {
              console.warn("carx məlumatı yüklənə bilmədi:", err);
            }
          }
        }

        // 🔥 Bitmişlər sona keçirilsin
        const sorted = all
          .filter((l) => l.isAccept === true && l.lotoreyaDate)
          .sort((a, b) => {
            const aFinished = !!a.carx?.winnerUserId;
            const bFinished = !!b.carx?.winnerUserId;

            if (aFinished === bFinished) {
              return new Date(a.lotoreyaDate) - new Date(b.lotoreyaDate);
            }

            return aFinished ? 1 : -1;
          });

        setLotoreyas(sorted);

      } catch (error) {
        console.error("Lotoreyalar yüklənərkən xəta:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadLotoreyas();
  }, []);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  const closeBalanceModal = () => {
    setShowBalanceModal(false);
    setBalanceMessage("");
  };

  const handleConfirmBuy = async () => {
    try {
      const userId = localStorage.getItem('motoTaksiUserId');
      const user = await UserController.getUserById(userId);

      if (!user) {
        alert('İstifadəçi tapılmadı!');
        setShowConfirmModal(false);
        return;
      }

      if (selectedLotoreyaForBuy.biletPrice === 0) {
        const userTickets = (selectedLotoreyaForBuy.bilets || []).filter(bilet => {
          return bilet.userId === Number(userId);
        });

        if (userTickets.length >= 1) {
          alert('Qiyməti 0 olan lotoreya üçün yalnız bir bilet ala bilərsiniz.');
          setShowConfirmModal(false);
          return;
        }
      }

      if (user.balance < selectedLotoreyaForBuy.biletPrice) {
        setBalanceMessage(`Balans kifayət etmir! Mövcud balans: ${user.balance} ₼, tələb olunan: ${selectedLotoreyaForBuy.biletPrice} ₼`);
        setShowBalanceModal(true);
        setShowConfirmModal(false);
        return;
      }

      const soldCount = selectedLotoreyaForBuy.totalBiletCount
        ? Math.round(((selectedLotoreyaForBuy.bilets?.length || 0) / selectedLotoreyaForBuy.totalBiletCount) * 100)
        : 0;

      if (soldCount >= 100 || selectedLotoreyaForBuy.carx?.winnerUserId) {
        alert('Bu lotoreya üçün artıq bilet almaq mümkün deyil!');
        setShowConfirmModal(false);
        return;
      }

      const result = await BiletController.buyBilet(selectedLotoreyaForBuy.lotoreyaId, userId);

      if (result) {
        alert(`✅ Bilet uğurla alındı! Bilet kodu: ${result.code}`);

        setLotoreyas((prevLotoreyas) =>
          prevLotoreyas.map((lotoreya) =>
            lotoreya.id === selectedLotoreyaForBuy.lotoreyaId
              ? {
                ...lotoreya,
                bilets: [...lotoreya.bilets, result],
              }
              : lotoreya
          )
        );

        // Yeni modal açılacaq
        setShowSuccessModal(true);

      } else {
        alert('Xəta baş verdi, bilet alınmadı.');
      }

      setShowConfirmModal(false);
    } catch (error) {
      console.error('Bilet alışı zamanı xəta:', error);
      alert(error.response?.data?.message || 'Xəta baş verdi!');
      setShowConfirmModal(false);
    }
  };

  return (
    <div className="lottery-wrapper">
      {isLoading ? (
        <div className="loading">Yüklənir...</div>
      ) : lotoreyas.length === 0 ? (
        <div className="no-lottery">Hazırda aktiv lotoreya yoxdur.</div>
      ) : (
        lotoreyas.map((lotoreya) => (

          <LotoreyaCard
            key={lotoreya.id}
            image={lotoreya.elan?.image}
            title={lotoreya.elan?.title}
            value={`${lotoreya.elan?.price} ₼`}
            price={`${lotoreya.biletPrice} ₼`}
            date={moment(lotoreya.lotoreyaDate).locale("az").format("LL")}
            sold={
              lotoreya.totalBiletCount
                ? Math.round(
                  ((lotoreya.bilets?.length || 0) /
                    lotoreya.totalBiletCount) *
                  100
                )
                : 0
            }
            onImageClick={() => handleImageClick(lotoreya.elan?.image)}
            disabled={
              lotoreya.totalBiletCount
                ? Math.round(
                  ((lotoreya.bilets?.length || 0) /
                    lotoreya.totalBiletCount) *
                  100
                ) >= 100 || lotoreya.carx?.winnerUserId // 🔥 Əgər qalib varsa, disable olacaq
                : false
            }
            winnerUser={lotoreya.carx?.winnerUser?.name || null} // 🔥 qalib adı göndəririk
            onBuyClick={() => {
              const userId = localStorage.getItem('motoTaksiUserId');
              if (!userId) {
                alert('Zəhmət olmasa əvvəlcə daxil olun.');
                return;
              }

              const sold = lotoreya.totalBiletCount
                ? Math.round(((lotoreya.bilets?.length || 0) / lotoreya.totalBiletCount) * 100)
                : 0;

              if (sold >= 100 || lotoreya.carx?.winnerUserId) {
                alert('Bu lotoreya üçün artıq bilet almaq mümkün deyil!');
                return;
              }

              // Modal üçün seçilən lotoreyanı saxlayırıq
              setSelectedLotoreyaForBuy({
                lotoreyaId: lotoreya.id,
                biletPrice: lotoreya.biletPrice,
                bilets: lotoreya.bilets || [], // Burada biletləri də əlavə edin
              });

              setShowConfirmModal(true);
            }}
          />

        ))
      )}

      {showConfirmModal && selectedLotoreyaForBuy && (
        <div className="confirm-modal-backdrop" onClick={() => setShowConfirmModal(false)}>
          <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>🎟️ Bilet Al</h3>
            <p>Bu biletin qiyməti: <b>{selectedLotoreyaForBuy.biletPrice} ₼</b></p>
            <p>Almaq istəyirsiniz?</p>
            <div className="button-group">
              <button className="confirm-btn" onClick={handleConfirmBuy}>
                ✅ Bəli, Al
              </button>
              <button className="cancel-btn" onClick={() => setShowConfirmModal(false)}>
                ❌ Ləğv et
              </button>
            </div>

          </div>
        </div>
      )}

      {showSuccessModal && (
        <div className="success-modal-backdrop" onClick={() => setShowSuccessModal(false)}>
          <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>✅ Biletiniz Uğurla Alındı!</h3>
            <p>Aldığınız Lotoreya Bilet barəsində yeniliklərdən xəbərdar olmaq üçün izləyin:</p>
            <div className="social-buttons">
              <a href="https://www.tiktok.com/@mototaksi.az" target="_blank" rel="noopener noreferrer">
                <div className="tiktok-success-btn">
                  <FaTiktok className="social-icon" /> TikTok
                </div>
              </a>
              <a href="https://chat.whatsapp.com/Lg1Emr5KfHeCagALQDg3sZ?mode=ac_c" target="_blank" rel="noopener noreferrer">
                <div className="whatsapp-success-btn">
                  <FaWhatsapp className="social-icon" /> WhatsApp
                </div>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Şəkil Modal */}
      {showImageModal && selectedImage && (
        <div className="image-modal-backdrop" onClick={closeImageModal}>
          <div className="image-modal-content">
            <img src={selectedImage} alt="Lotoreya Şəkli" />
          </div>
        </div>
      )}

      {showBalanceModal && (
        <div className="balance-modal-backdrop" onClick={closeBalanceModal}>
          <div className="balance-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>⚠️ Balans kifayət etmir</h3>
            <p>{balanceMessage}</p>
            <button
              onClick={() => {
                closeBalanceModal();
                navigate('/profile');
              }}
            >
              ➕ Balansı artır
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Lotoreya;

